import { useState } from "react";
import { Link } from "react-router-dom";
import { cx } from "class-variance-authority";
import { LayoutDashboard, Wrench, FileText } from "lucide-react";
import SidebarChevron from "@/assets/icons/SidebarChevron";
import { useData } from "@/stores/data";

export default function SidebarRepairCenter({ sidebarMinMax = false }) {
  const [rr, setRr] = useState(false);
  const [report, setReport] = useState(false);
  const { setCurrentExport } = useData();

  // Helper function to handle accordion behavior - close all other groups when one is opened
  const handleGroupToggle = (groupSetter, currentValue) => {
    // Close all groups
    setRr(false);
    setReport(false);
    // Toggle the target group
    groupSetter(!currentValue);
  };

  return (
    <>
      <Link
        to={"/repair-center/dashboard"}
        className={cx(
          "flex",
          "items-center",
          "gap-3",
          "px-4",
          "py-3",
          "rounded-lg",
          "text-gray-700",
          "hover:bg-blue-50",
          "hover:text-blue-700",
          "transition-all",
          "duration-200",
          "group",
          "whitespace-nowrap",
          sidebarMinMax && "justify-center",
        )}
      >
        <LayoutDashboard className="w-5 h-5 text-gray-400 group-hover:text-blue-600" />
        {!sidebarMinMax && (
          <span className="font-medium whitespace-nowrap">Dashboard</span>
        )}
      </Link>

      <button
        className={cx(
          "w-full",
          "flex",
          "items-center",
          "justify-between",
          "px-4",
          "py-3",
          "rounded-lg",
          "text-gray-700",
          "hover:bg-gray-100",
          "transition-all",
          "duration-200",
          "group",
        )}
        onClick={() => {
          handleGroupToggle(setRr, rr);
        }}
      >
        <div className="flex items-center gap-3">
          <Wrench className="w-5 h-5 text-gray-400 group-hover:text-gray-600" />
          {!sidebarMinMax && (
            <span className="font-medium whitespace-nowrap">
              Repair Request
            </span>
          )}
        </div>
        {!sidebarMinMax && (
          <SidebarChevron
            className={`transition-transform duration-200 ${
              rr ? "rotate-180" : ""
            }`}
          />
        )}
      </button>
      {rr && !sidebarMinMax && (
        <div className="ml-6 space-y-1 border-l-2 border-gray-100 pl-4">
          <Link
            to={"/repair-center/rr/all"}
            className={cx(
              "block",
              "px-3",
              "py-2",
              "text-sm",
              "text-gray-600",
              "hover:text-blue-600",
              "hover:bg-blue-50",
              "rounded-md",
              "transition-all",
              "duration-200",
              "whitespace-nowrap",
            )}
          >
            All
          </Link>
          <Link
            to={"/repair-center/rr/part-return"}
            className={cx(
              "block",
              "px-3",
              "py-2",
              "text-sm",
              "text-gray-600",
              "hover:text-blue-600",
              "hover:bg-blue-50",
              "rounded-md",
              "transition-all",
              "duration-200",
              "whitespace-nowrap",
            )}
          >
            Part Return RRT
          </Link>
        </div>
      )}

      {/* Report */}
      <button
        onClick={() => {
          handleGroupToggle(setReport, report);
        }}
        className={cx(
          "w-full",
          "flex",
          "items-center",
          "justify-between",
          "px-4",
          "py-3",
          "rounded-lg",
          "text-gray-700",
          "hover:bg-gray-100",
          "transition-all",
          "duration-200",
          "group",
        )}
      >
        <div className="flex items-center gap-3">
          <FileText className="w-5 h-5 text-gray-400 group-hover:text-gray-600" />
          {!sidebarMinMax && (
            <span className="font-medium whitespace-nowrap">Report</span>
          )}
        </div>
        {!sidebarMinMax && (
          <SidebarChevron
            className={`transition-transform duration-200 ${
              report ? "rotate-180" : ""
            }`}
          />
        )}
      </button>
      {report && !sidebarMinMax && (
        <div className="ml-6 space-y-1 border-l-2 border-gray-100 pl-4">
          <button
            onClick={() => {
              setCurrentExport("rrt reporting");
            }}
            className={cx(
              "block",
              "w-full",
              "text-left",
              "px-3",
              "py-2",
              "text-sm",
              "text-gray-600",
              "hover:text-blue-600",
              "hover:bg-blue-50",
              "rounded-md",
              "transition-all",
              "duration-200",
            )}
          >
            RRT Reporting
          </button>
          <button
            onClick={() => {
              setCurrentExport("part usage");
            }}
            className={cx(
              "block",
              "w-full",
              "text-left",
              "px-3",
              "py-2",
              "text-sm",
              "text-gray-600",
              "hover:text-blue-600",
              "hover:bg-blue-50",
              "rounded-md",
              "transition-all",
              "duration-200",
            )}
          >
            Part Usage
          </button>
        </div>
      )}
    </>
  );
}
